import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';
import EmailConfig from '../Settings/EmailConfig';
import EmailLog from '../SystemMonitoring/EmailLog';

const EmailManagement = () => {
  const { isDark } = useTheme();
  const [activeTab, setActiveTab] = useState('config');

  return (
    <div className={`space-y-6 ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className={`text-2xl font-bold flex items-center space-x-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            <Mail className="h-7 w-7 text-blue-600" />
            <span>Email Management</span>
          </h1>
          <p className={`mt-1 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
            Configure email settings and monitor email activity
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className={`border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          <button
            onClick={() => setActiveTab('config')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'config'
                ? `${isDark ? 'border-blue-500 text-blue-400' : 'border-blue-500 text-blue-600'}`
                : `${isDark ? 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`
              }
            `}
          >
            Email Configuration
          </button>
          <button
            onClick={() => setActiveTab('logs')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'logs'
                ? `${isDark ? 'border-blue-500 text-blue-400' : 'border-blue-500 text-blue-600'}`
                : `${isDark ? 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`
              }
            `}
          >
            Email Logs
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'config' && <EmailConfig />}
        {activeTab === 'logs' && <EmailLog />}
      </div>
    </div>
  );
};

export default EmailManagement;

